import { createRoot } from 'react-dom/client';
import Terminal from './terminal';
import './styles.css';

createRoot(document.getElementById('root')!).render(<Terminal />);
